import React, { type SVGProps } from 'react';

const Headings = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 24 24"
    width="70"
    height="70"
  >
    <path
      d="M20.18 19.99c.16 0 .3-.09.37-.23.08-.15.12-.33.12-.5a.584.584 0 00-.19-.46.732.732 0 00-.43-.16h-.56c-.18-.03-.34-.09-.49-.19-.31-.42-.43-.95-.33-1.46V7.17c-.11-.58 0-1.18.33-1.68.14-.08.3-.12.46-.13H20c.15 0 .3-.05.42-.15.13-.12.2-.29.18-.46 0-.18-.04-.35-.13-.5a.428.428 0 00-.37-.26h-5.43a.407.407 0 00-.39.23c-.09.15-.13.32-.13.5-.03.21.08.42.27.52.22.09.45.14.69.14.21-.01.42.04.61.13.34.48.47 1.09.36 1.67v3.66c-.13.01-.27.01-.4 0h-7.3c-.14.01-.27.01-.41 0V7.17c-.11-.59.02-1.19.36-1.67.14-.08.29-.13.45-.14h.52a.7.7 0 00.4-.15c.13-.11.19-.28.18-.45 0-.18-.04-.35-.13-.5a.407.407 0 00-.42-.27H3.82c-.16 0-.3.09-.37.23-.08.15-.12.33-.12.5-.01.17.06.35.19.47.12.1.27.15.43.15h.55c.18 0 .35.05.5.14.07.05.13.11.17.19.04.1.06.21.06.32 0 .13.02.26.07.38.01.15.01.29 0 .44v10.11c.1.52-.01 1.05-.3 1.49-.13.08-.28.14-.44.16l-.49.08c-.14.02-.27.08-.37.18a.63.63 0 00-.16.47c0 .17.04.33.13.47.06.13.19.21.33.22h5.54c.19.04.38-.05.46-.23.09-.15.13-.32.13-.5a.565.565 0 00-.21-.47c-.14-.1-.3-.16-.47-.16h-.59c-.18-.01-.35-.06-.5-.14-.36-.49-.5-1.11-.39-1.71v-4.21c.18-.02.35-.02.53 0h7c.17-.02.35-.02.52 0v4.42c.1.51-.03 1.04-.34 1.46-.15.08-.3.14-.47.16l-.53.07c-.15.01-.3.08-.41.18-.13.13-.19.3-.18.48 0 .17.05.33.14.47.08.14.23.22.39.21l1.38-.03h4.18z"
      vectorEffect="non-scaling-stroke"
      fill="currentColor"
    />
  </svg>
);

export default Headings;
